<template>
  <div>
    <v-container class="pa-0" fluid>
      <v-row class="px-2" style="height: 48px; max-height: 48px">
        <ContenidoBase
          :EstadoBtn="EstadoBtn"
          :descripcion="'Reporte Ventas Comparativas Entre Fechas'"
          :show-absolute="false"
          :titulo="'Ventas Comparativas Entre Fechas'"
        />
      </v-row>

      <v-row>
        <!-- contenido central ------------------------------------------------------------------------------ -->
        <v-col :max-height="this.windowSize.height - 96">
          <v-app
            id="inspire"
            class="overflow-y-auto"
            v-bind:style="{ 'max-height': this.windowSize.height - 96 + 'px' }"
          >
            <!--- Formulario --->
            <v-container>
              <v-card color="grey lighten-3">
                <v-toolbar color="#BDBDBD" dense flat style="border: 1px solid #000000">
                  <v-avatar size="45" tile>
                    <img alt="Reporte" src="@/assets/iconos_micromarket/custom-reports.png" />
                  </v-avatar>

                  <span class="font-weight-light" style="font-size: 20px">
                    Reporte Ventas Comparativas Entre Fechas
                  </span>
                </v-toolbar>

                <hr />

                <v-container style="border: 1px solid #000000">
                  <v-form ref="form" v-model="valid" lazy-validation @submit.prevent="">
                    <v-row>
                      <!-- columna 1 -->
                      <v-col cols="12" md="6" sm="6">
                        <!--- Desde --->
                        <v-text-field
                          v-model="datos.desde"
                          :rules="[$rules.required]"
                          dense
                          label="Desde:"
                          outlined
                          type="date"
                          @blur="blurDesde"
                        >
                          <template v-slot:prepend>
                            <i class="fa fa-calendar" style="font-size: 20px; width: 20px"></i>
                          </template>
                        </v-text-field>

                        <!--- Sucursal --->
                        <v-autocomplete
                          v-model="datos.sucursal"
                          :items="sucursalList"
                          clearable
                          dense
                          item-text="descripcion"
                          label="Sucursal"
                          outlined
                          return-object
                          @focus.once="findAllSucursales"
                        >
                          <template v-slot:prepend>
                            <i class="fa fa-sitemap" style="font-size: 20px; width: 20px"></i>
                          </template>
                        </v-autocomplete>
                      </v-col>

                      <!-- columna 2 -->
                      <v-col cols="12" md="6" sm="6">
                        <v-text-field
                          v-model="datos.hasta"
                          :rules="[$rules.required]"
                          dense
                          label="Hasta:"
                          outlined
                          type="date"
                          @blur="blurHasta"
                        >
                          <template v-slot:prepend>
                            <i class="fa fa-calendar" style="font-size: 20px; width: 20px"></i>
                          </template>
                        </v-text-field>

                        <div class="d-flex justify-center">
                          <v-radio-group v-model="datos.showValores" row>
                            <v-radio :value="false" label="Ventas en Galones"></v-radio>
                            <v-radio :value="true" label="Ventas en Valores"></v-radio>
                          </v-radio-group>
                        </div>
                      </v-col>
                      <!-- fn columna 2 -->
                    </v-row>
                  </v-form>
                </v-container>

                <hr />

                <ModalReporteFiltros ref="ModRepFilt" :Datos="datos" @DataReporteBasico="DDataReporteBasico" />
              </v-card>
            </v-container>
            <!-- fn Formulario-Historial de consumo del cliente-->
          </v-app>
        </v-col>
        <!-- fn contenido central ------------------------------------------------------------------------------------->
      </v-row>
    </v-container>
    <!-- Modales -------------------------------------------------------------------------------------------------->

    <!------------otras funciones---------------->
    <v-snackbar
      v-model="aalert.estado"
      :color="aalert.color"
      :timeout="120000"
      :vertical="true"
      style="margin-top: 20%"
      top="top"
    >
      {{ aalert.nombre }}
      <v-btn dark text @click="aalert.estado = false">Close</v-btn>
    </v-snackbar>

    <!-- fn Modales ----------------------------------------------------------------------------------------------->
  </div>
</template>

<script>
  import { EventBus } from "@/event-bus"
  import BarraBusqueda2 from "../../components/BarraBusquedaDinam"
  import ContenidoBase from "../../components/ContenidoBase"
  import ModalReporteFiltros from "../../components/ModalReporteFiltros2"

  import { fechaNueva, FormatoFecha } from "@/js/Funciones.js"

  export default {
    components: {
      BarraBusqueda2,
      ContenidoBase,
      ModalReporteFiltros,
    },

    mounted() {
      EventBus.$on("abrirMenuizquierdo", this.abrirTabla)
      this.$refs.ModRepFilt.CrearObjecto = this.validarObjecto
      EventBus.$on("onResize", this.onResize)
    },

    data: () => ({
      windowSize: { width: "auto", height: "auto" },
      Rcliente: [],
      datos: {
        nombre: "Ventas Comparativas Entre Fechas",
        titulo: "Ventas Comparativas Entre Fechas",
        UrlImprimir: "/reportes/estaciones/imprimirVentasComparativas",
        UrlExel: "/reportes/estaciones/excelVentasComparativas",

        desde: new Date().toISOString().split("T")[0],
        hasta: new Date().toISOString().split("T")[0],
        sucursal: null,
        showValores: false,
      },

      sucursalList: [],

      EstadoBtn: {
        BarraTablaDinamicaAprir: false,
        nuevo: false,
        guardar: false,
        eliminar: false,
        anular: false,
        imprimir: false,
        vercuenta: false,
        guardartemporal: false,
        restaurartemporal: false,
        importarDato: false,
        cargarProducto: false,
        ImprimirproductoInv: false,
      },

      text: "",
      valid: true,
      BarraTablaDinamicaAprir: false,
      BarraSecundariaAprir: false,

      aalert: {
        estado: false,
        color: null,
      },
    }),

    methods: {
      FormatoFecha,
      fechaNueva,
      onResize(e) {
        this.windowSize = e
      },

      // Validando el formulario y luego configurando el valor de la propiedad cliente del objeto
      validarObjecto() {
        if (!this.$refs.form.validate()) {
          this.$refs.ModRepFilt.detener = true
          return
        } else {
          this.$refs.ModRepFilt.detener = false
        }
      },

      // Buscar todas las sucursales
      findAllSucursales() {
        this.$axios
          .get(this.$hostname + this.$hName + "/sucursal/findallActivos/", {
            headers: this.$store.getters.GetheadersAxios,
          })
          .then((res) => {
            this.sucursalList = res.data
          })
          .catch((err) => {
            console.error(err)
          })
      },

      abrirTabla() {
        this.BarraTablaDinamicaAprir = !this.BarraTablaDinamicaAprir
      },

      save() {},
      remove() {},
      anular() {},
      imprimirList() {},
      DDataReporteBasico() {},

      newwnuevo() {},

      // Valida si el campo esta nulo, si lo esta coloca la fecha actual.
      blurDesde() {
        if (!this.datos.desde) {
          this.datos.desde = this.fechaNueva()
        }
      },

      // Valida si el campo esta nulo, si lo esta coloca la fecha actual.
      blurHasta() {
        if (!this.datos.hasta) {
          this.datos.hasta = this.fechaNueva()
        }
      },

      alerta(e, l) {
        if (l === "bien") {
          this.aalert.estado = true
          this.aalert.color = "success"
          this.aalert.nombre = e
          this.newwnuevo()
        }

        if (l === "error") {
          this.aalert.estado = true
          this.aalert.color = "error"
          this.aalert.nombre = e
          this.ejecucion = false
        }
      },
    },
  }
</script>

<style></style>
